// extracted by mini-css-extract-plugin
export default {"containerFooter":"footer_containerFooter__-x2lh"};